import React from 'react';
import Select from 'react-select';
import BaseComponent from '../../baseComponent.js';
import styles from "./styles.scss";

export class SelectionControl extends BaseComponent {

  constructor(props) {
    super(props);
  }

  handleChange(option) {
    const selected = this.props.metaData.selections.find(s => s.id === option.value);
    this.props.onChange(selected);
  }

  render() {
    const selectedId = this.props.selected ? this.props.selected.id : '';
    const options = this.props.metaData.selections.map(s => {
      return {value: s.id, label: s.description}
    });
    return (
    <div className={styles.selectionControl}>
      {this.props.showLabel ? <div className={styles.floatLabel}>{this.props.metaData.title}</div> : null}
      <Select
        name="variable-type"
        value={selectedId}
        options={options}
        onOpen={this.props.handleOpened}
        onClose={this.props.handleClosed}
        onChange={this.handleChange}/>
    </div>

    );
  }
}

SelectionControl.propTypes = {
  selected: React.PropTypes.object,
  metaData: React.PropTypes.object.isRequired,
  onChange: React.PropTypes.func.isRequired,
  handleOpened: React.PropTypes.func.isRequired,
  handleClosed: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/selectionControl.jsx